export default __webpack_public_path__ + "static/media/girl_phone.55bfcd5b.svg";